import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

function Select({
	children,
	name,
	error,
	defaultValue,
	options,
	register,
	required,
	...rest
}) {
	const inputClass = classnames("input", { "is-danger": !!error });

	return (
		<div className="field">
			<label htmlFor={name} className="label">
				{children}
			</label>
			<div className="control">
				<div className="select">
					<select
						{...rest}
						ref={register({ required })}
						className={inputClass}
						name={name}
						id={name}
					>
						<option value="">{defaultValue}</option>
						{options.map(option => (
							<option key={option.value} value={option.value}>
								{option.label}
							</option>
						))}
					</select>
				</div>
			</div>
			{error && <p className={"help is-primary"}>{error.message}</p>}
		</div>
	);
}

Select.defaultProps = {
	error: null,
	required: false
};

Select.propTypes = {
	children: PropTypes.string.isRequired,
	error: PropTypes.shape({}),
	name: PropTypes.string.isRequired,
	pattern: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.shape({ value: PropTypes.object, message: PropTypes.string })
	]),
	register: PropTypes.func.isRequired,
	required: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.shape({ value: PropTypes.bool, message: PropTypes.string })
	]),
	options: PropTypes.arrayOf(PropTypes.object).isRequired,
	defaultValue: PropTypes.string.isRequired
};

export default Select;